export function parse_http_url(value) {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error("A valid URL is required.");
  }

  let url;
  try {
    url = new URL(value);
  } catch {
    throw new Error("A valid absolute HTTP(S) URL is required.");
  }

  if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) {
    throw new Error("Only HTTP(S) URLs without embedded credentials are allowed.");
  }

  return url;
}

export function validate_endpoint_url(value, configured_endpoint) {
  const endpoint = parse_http_url(configured_endpoint);
  const url = parse_http_url(value);
  const endpoint_path = endpoint.pathname.replace(/\/$/, "");
  if (url.origin !== endpoint.origin ||
      (url.pathname !== endpoint_path && !url.pathname.startsWith(`${endpoint_path}/`))) {
    throw new Error("The request URL is outside the configured endpoint.");
  }

  return url.href;
}
